import React from 'react';
import PropTypes from 'prop-types';

import { clickAsLink } from 'helpers/link_helpers';

export function Row({ importObject }) {
  const goToImport = (event) => {
    clickAsLink(window, importObject.importPath, event);
  };

  return (
    <tr className="clickable" onClick={goToImport}>
      <td>{importObject.name}</td>
      <td>{importObject.status}</td>
      <td>{importObject.info}</td>
    </tr>
  );
}

Row.propTypes = {
  importObject: PropTypes.shape({
    name: PropTypes.string,
    status: PropTypes.string,
    info: PropTypes.string,
    importPath: PropTypes.string
  }).isRequired,
};

export default Row;
